module.exports = __webpack_public_path__ + "static/media/AFP-ERP-2.18a6714d.jpg";